export enum PracticeManagementStep {
  RegistraRitornoAccertamentoMessi = 0,
  RitornoAccertamentoMessi = 1,
  AnnulloAccertamento = 2,
  RichiestaUlterioriAccertamenti = 3,
  RichiestaUlterioreAccertamentoMessi = 4,
  RegistraSospensionePratica = 5,
  RegistraFineSospensionePratica = 6,
  StampaComunicazioneOstativa = 7,
  RitornoComunicazioneOstativa = 8,
  StampaComunicazioneControInteressato = 9,
  RettificaIndirizzo = 10,
  Contatti = 11,
  Allegati = 12,
  CancellaPersona = 13,
  ChiusuraPositiva = 14,
  ChiusuraNegativa = 15,
  ChiusuraPraticaErrore = 16,
  RichiestaAccertamento = 17,
}

export enum PracticeDraftStep {
  RegisterOffice = 0,
  Family = 1,
  Residence = 2,
  Documents = 3,
  Irricevibilita = 4,
  Recap = 6,
  AccertamentoMessi = 5,
  ExceptionList = 7,
  Annullament = 8,
}

export enum PracticeDraftBEStep {
  RegisterOffice = 1,
  Family = 2,
  Residence = 3,
  Documents = 4,
  Irricevibilita = 5,
  Recap = 7,
  AccertamentoMessi = 6,
  ExceptionList = 8,
  Annullament = 9,
}

export enum TypeInitiative {
  Anpr = 'R',
  ElixForm = 'E',
  idUfficio = '2',
  idPersonaLegittima = '1',
}
